<div class="container my-5 pt-5 altura-ajustavel">
  <div class="row justify-content-md-center">
    <div class="col-md-8" *ngFor="let item of data">
      <div [innerHTML]="item.Conteudo | safeHtml"></div>
    </div>
    <div class="divider"></div>
  </div>
</div>
